import { Button, Col, Divider, Form, Image, Input, Row, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import Api from '../../Redux/common/api';
import { URL } from '../../Redux/common/url';
import { toast } from 'react-toastify';
import { PlusOutlined } from '@ant-design/icons';
import OurTeamTable from './OurTeamTable';
import { useDispatch, useSelector } from 'react-redux';
import { allapiAction } from '../../Redux/common/action';
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const OurTeam = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState([]);
  const dispatch = useDispatch();

  const our_team_list = useSelector((state) =>
    state?.allapi?.get_our_team_list ? state?.allapi?.get_our_team_list.map((item) => {
      item.key = item._id
      return item
    }) : []
  );

  useEffect(() => {
    dispatch(allapiAction.ourTeamMembers());
    return () => { };
  }, [dispatch]);
  const addTeam = async (data) => {
    try {
      const token = localStorage.getItem("admin_token");
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      setLoading(true);
      const response = await Api.post(`${URL.addteam}`, data, config);
      dispatch(allapiAction.ourTeamMembers());

      setLoading(false);
      form.resetFields();

      setFileList([]);
      toast.success(response?.data?.message);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message || "some error occured!!");
    }
  }

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleFileChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    const team_image = newFileList[0]?.originFileObj ? await getBase64(newFileList[0]?.originFileObj) : '';
    form.setFieldsValue({ team_image: team_image });
  };

  const handleTeamImage = async (file) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg';
    if (!isJpgOrPng) {
      toast.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      toast.error('Image must smaller than 2MB!');
    }

    return (isJpgOrPng && isLt2M) ? false : Upload.LIST_IGNORE;
  }

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        style={{
          padding: '24px',
          background: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
        onFinish={addTeam}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please enter name!',
                },
              ]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Designation"
              name="designation"
              rules={[
                {
                  required: true,
                  message: 'Please enter designation!',
                },
              ]}
            >
              <Input placeholder="Enter designation" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: 'Please enter description!',
                },
              ]}
            >
              <Input.TextArea maxLength={500} placeholder="Short description for the team" rows={5} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Team Image" name="team_image">
              <Upload
                beforeUpload={handleTeamImage}
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleFileChange}
                maxCount={1}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </Form.Item>
            {previewImage && (
              <Image
                wrapperStyle={{
                  display: 'none',
                }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType='submit' disabled={loading}>Submit</Button>
        </Form.Item>
      </Form>
      <Divider style={{ border: "2px solid #000000d9", borderRadius: "5px" }} />
      <OurTeamTable our_team_list={our_team_list} />
    </div>
  )
}

export default OurTeam